import { render, staticRenderFns } from "./molecule.swatchGroup.vue?vue&type=template&id=ae4e2d16"
import script from "./molecule.swatchGroup.vue?vue&type=script&lang=ts"
export * from "./molecule.swatchGroup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports